import React, { useState } from 'react';
import './ProductCard.css';

const ProductCard = ({ initialSoldOut = false }) => {
  const [isSoldOut] = useState(initialSoldOut);
  const cardClassName = `product-card${isSoldOut ? ' product-card--sold-out' : ''}`;

  return (
    <div className={cardClassName}>
      <div className="product-image">
        <img
          src="https://vieta.es/cdn/shop/files/8431543120931_3113082b-e8a8-4d6d-8a12-cba196569d15.jpg?v=1760419557&width=2000"
          alt="Producte Genèric"
        />
      </div>

      <div className="product-info">
        <h2 className="product-title">Auriculars Inalàmbrics Pro</h2>

        <p className="product-description">
          Cancel·lació de soroll avançada, 30 hores de bateria i so d'alta fidelitat.
          El disseny ergonòmic garanteix la màxima comoditat.
        </p>

        <div className="product-price-section">
          <span className="current-price">99,99 €</span>
          <span className="old-price">149,99 €</span>
          <span className="price-spacer"></span>
          <span className="discount-label">OFERTA</span>
        </div>

        <button
          className="add-to-cart-btn"
          disabled={isSoldOut}
        >
          {isSoldOut ? 'Esgotat' : 'Afegir a la cistella'}
        </button>
      </div>
    </div>
  );
};

export default ProductCard;